import React from 'react';
import { connect } from 'react-redux'
import { Router, Route, Link, Redirect } from "react-router-dom";
import Dashboard from './pages/Dashboard';
import ConstructionPage from './pages/ConstructionPage';
import FaqPage from './pages/FaqPage';
import IncompleteOrderPage from './pages/IncompleteOrderPage';
import NewOrderPage from './pages/NewOrderPage';
import OrderStatusPage from './pages/OrderStatusPage';
import OrderStatusRequestPage from './pages/OrderStatusRequestPage';
import OrderHelpPage from './pages/OrderHelpPage';
import OrderRMAPage from './pages/OrderRMAPage';
import UpdateOrderPage from './pages/UpdateOrderPage';
import CancelOrderPage from './pages/CancelOrderPage';
import ExchangeOrderPage from './pages/ExchangeOrderPage';
import ReturnOrderPage from './pages/ReturnOrderPage';
import RefundOrderPage from './pages/RefundOrderPage';
import RefundOrderRequestPage from './pages/RefundOrderRequestPage';
import ReplaceOrderPage from './pages/ReplaceOrderPage';
import SearchPage from './pages/SearchPage';
import SalesPage from './pages/SalesPage';
import Popups from './popups/Popups';
import LeftMenu from './menus/LeftMenu';
import TopMenu from './menus/TopMenu';
import BottomMenu from './menus/BottomMenu';
import { dot } from '../lib/obj';
import { parseQuery } from '../lib/formats';
import './Main.css';

/*
 * Fix scroll position when jumpoing to new pages
**/
import { createBrowserHistory } from 'history'
export const history = createBrowserHistory();
history.listen((location, action) => {
  if (action === "PUSH") {
    window.scrollTo(0,0);
  }
});

class Main extends React.Component {

  render() {
    let pages = true ? this.loggedInUI() : <div/>;
    return (
      <Router history={history}>
        <div className="Frame">
          <Popups/>
          <div className="TopSpace"/>
          <TopMenu/>
          {pages}
          <BottomMenu/>
        </div>
      </Router>
    );
  }

  /**
   * Helps render the logged in UI
  **/
  loggedInUI() {
    return (
      <div className="loggedInUI">
        <div className="Pages">
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/dashboard" render={({match})=>{
            return <Dashboard key="all" title="Home"/>
          }} />
          <Route exact path="/faq" render={({match})=>{
            let query = parseQuery(history.location.search);
            return <FaqPage key="faqPage" title="FAQ" back="Back" query={query}/>
          }} />
          <Route exact path="/order" render={({match})=>{
            return <OrderHelpPage key="orderHelp" title="Order Help" back="Back"/>
          }} />
          <Route exact path="/order/cancel" render={({match})=>{
            return <CancelOrderPage key="orderCancel" title="Cancel Help" back="Back"/>
          }} />
          <Route exact path="/order/incomplete" render={({match})=>{
            return <IncompleteOrderPage key="orderIncomplete" title="Incomplete Order" back="Back"/>
          }} />
          <Route exact path="/order/new" render={({match})=>{
            return <NewOrderPage key="orderNew" title="New Order Help" back="Back"/>
          }} />
          <Route exact path="/order/update" render={({match})=>{
            return <UpdateOrderPage key="orderUpdate" title="Update Order Help" back="Back"/>
          }} />
          <Route exact path="/order/return" render={({match})=>{
            return <ReturnOrderPage key="orderReturn" title="Return" back="Back"/>
          }} />
          <Route exact path="/order/status" render={({match})=>{
            return <OrderStatusPage key="orderStatus" title="Order Status" back="Back"/>
          }} />
          <Route exact path="/order/status-request" render={({match})=>{
            return <OrderStatusRequestPage key="orderStatusRequest" title="Order Status Request" back="Back"/>
          }} />
          <Route exact path="/rma" render={({match})=>{
            return <OrderRMAPage key="orderRMA" title="Order Help" back="Back"/>
          }} />
          <Route exact path="/rma/exchange" render={({match})=>{
            return <ExchangeOrderPage key="orderExchange" title="Exchange" back="Back"/>
          }} />
          <Route exact path="/rma/refund" render={({match})=>{
            return <RefundOrderPage key="orderRefund" title="Refund" back="Back"/>
          }} />
          <Route exact path="/rma/refund-request" render={({match})=>{
            return <RefundOrderRequestPage key="orderRefundRequest" title="Refund" back="Back"/>
          }} />
          <Route exact path="/rma/replace" render={({match})=>{
            return <ReplaceOrderPage key="orderReplace" title="Replace" back="Back"/>
          }} />
          <Route exact path="/search" render={({match})=>{
            let query = parseQuery(history.location.search);
            return <SearchPage key="search" title="Search" back="Back" term={`${query.term}`.replace('+',' ')}/>
          }} />
          <Route exact path="/sales" render={({match})=>{
            return <SalesPage key="sales" title="Sales" back="Back"/>
          }} />
          <Route exact path="/construction" render={({match})=>{
            return <ConstructionPage key="construction" title="Under Construction" back="Back"/>
          }} />
          <Route exact path="/construction" render={({match})=>{
            return <ConstructionPage key="construction" title="Under Construction" back="Back"/>
          }} />
          <Route exact path="/files/:loc" render={({match})=>{
            return <ConstructionPage key="construction" title="Under Construction" back="Back"/>
          }} />
        </div>
      </div>
    );
  }

}

const mapState = (state, props) => {
  return {
    inventory: state.inventory,
    login: dot(state.session,"login")
  }
};

const mapDispatch = (dispatch) => {
  return {}
};

export default connect(
  mapState,
  mapDispatch
)(Main)
